export const MEDIA_TYPE = {
    JSON: 'application/json',
    FORM_DATA: 'multipart/form-data'
}